import type { Category } from "@/services/api/categories";
import {
  useCategoriesPanel,
  CategoryFormDialog,
  DeleteConfirmDialog,
  AttributesModal,
  CategoryTable,
  CategoryPanelHeader,
} from "./categories";

export function CategoriesPanel() {
  const {
    categories,
    isLoading,
    sortField,
    sortDirection,
    isCreateDialogOpen,
    editingCategory,
    deletingCategory,
    attributesCategory,
    handleSort,
    handleReorder,
    handleCreate,
    handleUpdate,
    handleDelete,
    setIsCreateDialogOpen,
    setEditingCategory,
    setDeletingCategory,
    setAttributesCategory,
    createIsLoading,
    updateIsLoading,
    deleteIsLoading,
    categoriesCount,
  } = useCategoriesPanel();

  return (
    <div className="w-full space-y-6">
      <CategoryPanelHeader
        categoriesCount={categoriesCount}
        onCreateClick={() => setIsCreateDialogOpen(true)}
      />

      <div className="rounded-xl border border-grid-200 bg-white shadow-sm">
        {isLoading ? (
          <div className="py-12 text-center text-sm text-ink-500">
            Loading categories...
          </div>
        ) : (
          <CategoryTable
            categories={categories}
            sortField={sortField}
            sortDirection={sortDirection}
            onSort={handleSort}
            onReorder={handleReorder}
            onEdit={(category: Category) => setEditingCategory(category)}
            onDelete={(category: Category) => setDeletingCategory(category)}
            onViewAttributes={(category: Category) =>
              setAttributesCategory(category)
            }
          />
        )}
      </div>

      <CategoryFormDialog
        open={isCreateDialogOpen}
        onOpenChange={setIsCreateDialogOpen}
        onSubmit={handleCreate}
        isLoading={createIsLoading}
      />

      <CategoryFormDialog
        open={!!editingCategory}
        onOpenChange={(open) => !open && setEditingCategory(null)}
        category={editingCategory || undefined}
        onSubmit={handleUpdate}
        isLoading={updateIsLoading}
      />

      <DeleteConfirmDialog
        open={!!deletingCategory}
        onOpenChange={(open) => !open && setDeletingCategory(null)}
        category={deletingCategory}
        onConfirm={handleDelete}
        isLoading={deleteIsLoading}
      />

      <AttributesModal
        open={!!attributesCategory}
        onOpenChange={(open) => !open && setAttributesCategory(null)}
        category={attributesCategory}
      />
    </div>
  );
}
